(() => {
  const initTabs = (root) => {
    if (root.dataset.clTabsReady === 'true') return;
    root.dataset.clTabsReady = 'true';

    const tabs = [...root.querySelectorAll('[data-cl-tab]')];
    const panels = [...root.querySelectorAll('[data-cl-tab-panel]')];

    const activate = (tab) => {
      const panelId = tab.getAttribute('aria-controls');

      tabs.forEach((candidate) => {
        const active = candidate === tab;
        candidate.setAttribute('aria-selected', String(active));
        candidate.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        const active = panel.id === panelId;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        activate(tabs[nextIndex]);
        tabs[nextIndex].focus();
      });
    });
  };

  const initFaq = (root) => {
    if (root.dataset.clFaqReady === 'true') return;
    root.dataset.clFaqReady = 'true';

    const questions = [...root.querySelectorAll('[data-cl-faq-question]')];

    questions.forEach((question) => {
      question.addEventListener('click', () => {
        const opening = question.getAttribute('aria-expanded') !== 'true';

        questions.forEach((candidate) => {
          const answer = root.querySelector(`#${candidate.getAttribute('aria-controls')}`);
          candidate.setAttribute('aria-expanded', 'false');
          if (answer) {
            answer.classList.remove('is-open');
            answer.hidden = true;
          }
        });

        if (opening) {
          const answer = root.querySelector(`#${question.getAttribute('aria-controls')}`);
          question.setAttribute('aria-expanded', 'true');
          if (answer) {
            answer.classList.add('is-open');
            answer.hidden = false;
          }
        }
      });
    });
  };

  const initYouTube = (root) => {
    if (root.dataset.clYoutubeReady === 'true') return;
    root.dataset.clYoutubeReady = 'true';

    const poster = root.querySelector('.cl-pdp-mia__video-poster');
    if (!poster) return;

    poster.addEventListener('click', () => {
      const iframe = document.createElement('iframe');
      const videoId = root.dataset.videoId;
      iframe.width = '500';
      iframe.height = '294';
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0&playsinline=1`;
      iframe.title = root.dataset.videoTitle || '';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      root.replaceChildren(iframe);
      iframe.focus();
    });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-cl-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-cl-faq]').forEach(initFaq);
    scope.querySelectorAll('[data-cl-youtube]').forEach(initYouTube);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
